module.exports = __webpack_public_path__ + "img/product-placeholder-91.cef155f.png";